"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupWindowPosition = void 0;
/**
 * SharePoint property pane link popup window position.
 */
var PopupWindowPosition;
(function (PopupWindowPosition) {
    /**
     * Center.
     */
    PopupWindowPosition[PopupWindowPosition["Center"] = 0] = "Center";
    /**
     * Right top.
     */
    PopupWindowPosition[PopupWindowPosition["RightTop"] = 1] = "RightTop";
    /**
     * Left top.
     */
    PopupWindowPosition[PopupWindowPosition["LeftTop"] = 2] = "LeftTop";
    /**
     * Right bottom.
     */
    PopupWindowPosition[PopupWindowPosition["RightBottom"] = 3] = "RightBottom";
    /**
     * Left bottom.
     */
    PopupWindowPosition[PopupWindowPosition["LeftBottom"] = 4] = "LeftBottom";
})(PopupWindowPosition = exports.PopupWindowPosition || (exports.PopupWindowPosition = {}));
//# sourceMappingURL=propertyPaneLinkPopupWindowProperties.js.map